import { useDispatch, useSelector } from 'react-redux';

import { authentication } from '@perpay-web/authentication/singleton';
import { getIsLoadingOrUnrequested } from '@perpay-web/data-module/useDataModule';
import {
    analyticsPartnerHostedOnboardingApprovalClickAcceptAndContinue,
    analyticsPartnerHostedOnboardingApprovalClickCloseModal,
    analyticsPartnerHostedOnboardingApprovalClickInfoModal,
} from '@perpay-web/fintech/actions/analytics/partnerHostedOnboarding';
import { analyticsPerpayCreditCardOnboardingApprovedClickNotNow } from '@perpay-web/fintech/actions/analytics/perpayCreditCardOnboarding';
import CardApplicationApproved from '@perpay-web/fintech/components/composite/CardApplicationApproved/CardApplicationApproved';
import { cardFees } from '@perpay-web/fintech/constants/cardFeesConstants';
import { updateCardAccountApplicationForOnboardingDataModule } from '@perpay-web/fintech/dataModules/updateCardAccountApplicationsForOnboarding';
import {
    getCardApplicationCreditLimit,
    getCardApplicationMaterial,
    getCardApplicationApr,
    getCardApplicationUuid,
    getEstimatedCardMinimumPayment,
    useFetchCardApplicationStatusContext,
} from '@perpay-web/fintech/hooks/dataModule/useFetchCardApplicationStatusContext';
import { getOfferAmount } from '@perpay-web/fintech/selectors/ui/partnerOnboarding';
import {
    METAL_MATERIAL,
    SILVER_MATERIAL,
} from '@perpay-web/fintech/utils/cardAccountApplicationMetalUtils';

const CardApplicationApprovedContainer = ({
    applicationUuid,
    isUserInPremiumGroup,
}) => {
    const dispatch = useDispatch();

    // TODO fetch fees from API
    const monthlyFee = cardFees.MONTHLY_FEE;
    const oneTimeFee = cardFees.ONE_TINE_FEE;
    const metalCardFee = cardFees.METAL_CARD_FEE;

    const { dataRequest, state } = useFetchCardApplicationStatusContext();
    const cardAccountApplicationUuid = getCardApplicationUuid(state);
    const isLoading =
        !cardAccountApplicationUuid && getIsLoadingOrUnrequested(state);

    const estimatedCardMinimumPayment = getEstimatedCardMinimumPayment(state);
    const creditLimit = getCardApplicationCreditLimit(state);
    const apr = getCardApplicationApr(state);
    const cardMaterial = getCardApplicationMaterial(state);

    const partnerCode = authentication.getPartnerOnboardedCode();
    const welcomeOffer = useSelector(getOfferAmount);

    return (
        <CardApplicationApproved
            addPartnerStyling
            partnerCode={partnerCode}
            welcomeOffer={welcomeOffer}
            monthlyFee={monthlyFee}
            oneTimeFee={oneTimeFee}
            metalCardFee={metalCardFee}
            estimatedCardMinimumPayment={estimatedCardMinimumPayment}
            cardAccountApplicationUuid={cardAccountApplicationUuid}
            creditLimit={creditLimit}
            apr={apr}
            isMetalOrSilverCard={
                cardMaterial === METAL_MATERIAL ||
                cardMaterial === SILVER_MATERIAL
            }
            isUserInPremiumGroup={isUserInPremiumGroup}
            onClickAccept={() => {
                dispatch(
                    analyticsPartnerHostedOnboardingApprovalClickAcceptAndContinue(
                        cardAccountApplicationUuid,
                    ),
                );
                dispatch(
                    updateCardAccountApplicationForOnboardingDataModule.dataRequest(
                        { accepted_product: true },
                        cardAccountApplicationUuid,
                    ),
                );
            }}
            onClickNotNow={() => {
                dispatch(
                    analyticsPerpayCreditCardOnboardingApprovedClickNotNow(),
                );
            }}
            onOpenInfoModal={() =>
                dispatch(
                    analyticsPartnerHostedOnboardingApprovalClickInfoModal(),
                )
            }
            onCloseInfoModal={() =>
                dispatch(
                    analyticsPartnerHostedOnboardingApprovalClickCloseModal(),
                )
            }
            onMount={() => {
                if (applicationUuid && !cardAccountApplicationUuid) {
                    dataRequest(applicationUuid);
                }
            }}
            isLoading={isLoading}
        />
    );
};

export default CardApplicationApprovedContainer;
